module.exports = __webpack_public_path__ + "img/2.9fcf0f4e.webp";